export default Object.freeze({
  0: 'No Rate Ceiling',
  2: 'Credit Rate',
  3: 'Global Ceiling Override'
});
